import { render } from "./MainlandPhoneInput.vue?vue&type=template&id=61f40e55"
import script from "./MainlandPhoneInput.vue?vue&type=script&lang=js"
export * from "./MainlandPhoneInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__